// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../(User)/Provider";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        config: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    var _a;
    const result = {};
    switch ((_a = value.config) === null || _a === void 0 ? void 0 : _a.field) {
        case "email": {
            result.email = tsValueToJsonValueFns.string(value.config.value);
            break;
        }
        case "providerInfo": {
            result.providerInfo = encodeJson_1(value.config.value);
            break;
        }
        case "authId": {
            result.authId = tsValueToJsonValueFns.string(value.config.value);
            break;
        }
    }
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.email !== undefined)
        result.config = { field: "email", value: jsonValueToTsValueFns.string(value.email) };
    if (value.providerInfo !== undefined)
        result.config = { field: "providerInfo", value: decodeJson_1(value.providerInfo) };
    if (value.authId !== undefined)
        result.config = { field: "authId", value: jsonValueToTsValueFns.string(value.authId) };
    return result;
}
export function encodeBinary(value) {
    var _a;
    const result = [];
    switch ((_a = value.config) === null || _a === void 0 ? void 0 : _a.field) {
        case "email": {
            const tsValue = value.config.value;
            result.push([1, tsValueToWireValueFns.string(tsValue)]);
            break;
        }
        case "providerInfo": {
            const tsValue = value.config.value;
            result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
            break;
        }
        case "authId": {
            const tsValue = value.config.value;
            result.push([3, tsValueToWireValueFns.string(tsValue)]);
            break;
        }
    }
    return serialize(result);
}
const oneofFieldNumbersMap = {
    config: new Set([1, 2, 3]),
};
const oneofFieldNamesMap = {
    config: new Map([
        [1, "email"],
        [2, "providerInfo"],
        [3, "authId"],
    ]),
};
export function decodeBinary(binary) {
    var _a;
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    const wireFieldNumbers = Array.from(wireFields.keys()).reverse();
    oneof: {
        const oneofFieldNumbers = oneofFieldNumbersMap.config;
        const oneofFieldNames = oneofFieldNamesMap.config;
        const fieldNumber = wireFieldNumbers.find(v => oneofFieldNumbers.has(v));
        if (fieldNumber == null)
            break oneof;
        const wireValue = wireFields.get(fieldNumber);
        const wireValueToTsValueMap = {
            [1](wireValue) { return wireValueToTsValueFns.string(wireValue); },
            [2](wireValue) { return wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined; },
            [3](wireValue) { return wireValueToTsValueFns.string(wireValue); },
        };
        const value = (_a = wireValueToTsValueMap[fieldNumber]) === null || _a === void 0 ? void 0 : _a.call(wireValueToTsValueMap, wireValue);
        if (value === undefined)
            break oneof;
        result.config = { field: oneofFieldNames.get(fieldNumber), value: value };
    }
    return result;
}
